import React from "react";
import { Box } from "@100mslive/roomkit-react";

const LeftBorderBox = ({ show }: { show: boolean }) => (
  <Box
    css={{
      position: "absolute",
      left: "0",
      top: "22px",
      height: "32px",
      width: "4px",
      opacity: show ? "1" : "0",
      transition: "opacity 0.1s ease-in",
      backgroundColor: "$primary_bright",
      borderRadius: "0 $1 $1 0",
    }}
  />
);

export default LeftBorderBox;
